var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"http://35.240.240.18/mbs-api/privacy-policy.html","width":"100%","height":"1024"}})}
var staticRenderFns = []

export { render, staticRenderFns }